import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.chats');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-page-admin-chats',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.chats/view.scss */
:host {
  display: block;
  height: 100%;
}

.admin-page {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.admin-history {
  gap: 20px;
}

.admin-history__hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}

.admin-history__hero-copy {
  max-width: 560px;
}

.admin-history__eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 999px;
  background: #dcfce7;
  color: #047857;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.admin-history__hero-text {
  margin-top: 10px;
  color: #52525b;
  font-size: 13px;
  line-height: 1.7;
}

.admin-history__hero-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  min-width: 420px;
}

.admin-history__hero-stat {
  padding: 18px;
  border-radius: 24px;
  border: 1px solid rgba(228, 228, 231, 0.9);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 40px -36px rgba(15, 23, 42, 0.55);
}

.admin-history__hero-stat-label {
  color: #71717a;
  font-size: 11px;
}

.admin-history__hero-stat-value {
  margin-top: 8px;
  color: #09090b;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.admin-history__hero-stat-desc {
  margin-top: 6px;
  color: #71717a;
  font-size: 12px;
}

.admin-history__toolbar {
  display: grid;
  grid-template-columns: minmax(240px, 1fr) minmax(150px, 0.22fr) minmax(150px, 0.22fr) auto;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 28px;
  border: 1px solid rgba(228, 228, 231, 0.9);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 24px 48px -44px rgba(15, 23, 42, 0.6);
}

.admin-history__search {
  position: relative;
  min-width: 0;
}

.admin-history__search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #a1a1aa;
  font-size: 12px;
}

.admin-history__search-input {
  width: 100%;
  height: 48px;
  padding: 0 16px 0 42px;
  border: 1px solid #e4e4e7;
  border-radius: 16px;
  background: #ffffff;
  font-size: 14px;
  color: #18181b;
}

.admin-history__search-input:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.12);
}

.admin-history__filter-control {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.admin-history__filter-label {
  color: #71717a;
  font-size: 11px;
  font-weight: 700;
}

.admin-history__filter-input {
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 1px solid #e4e4e7;
  border-radius: 16px;
  background: #ffffff;
  color: #18181b;
  font-size: 13px;
  font-weight: 600;
}

.admin-history__filter-input:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.12);
}

.admin-history__filter-select {
  appearance: auto;
}

.admin-history__toolbar-actions,
.admin-history__detail-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-history__primary-button,
.admin-history__ghost-button,
.admin-history__page-btn {
  border: 0;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.admin-history__primary-button,
.admin-history__ghost-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 16px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
}

.admin-history__primary-button {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #ffffff;
}

.admin-history__primary-button:hover {
  transform: translateY(-1px);
}

.admin-history__ghost-button {
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
}

.admin-history__ghost-button:hover {
  background: #f8fafc;
  border-color: #d4d4d8;
}

.admin-history__workspace {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(340px, 0.88fr);
  gap: 20px;
  flex: 1 1 auto;
  min-height: 0;
}

.admin-history__list-panel,
.admin-history__detail-panel {
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 18px;
  border-radius: 28px;
  border: 1px solid rgba(228, 228, 231, 0.92);
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 24px 48px -44px rgba(15, 23, 42, 0.6);
}

.admin-history__detail-panel {
  position: sticky;
  top: 24px;
  max-height: calc(100dvh - 120px);
}

.admin-history__panel-head,
.admin-history__detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.admin-history__panel-title {
  color: #09090b;
  font-size: 15px;
  font-weight: 700;
}

.admin-history__panel-subtitle,
.admin-history__detail-session {
  margin-top: 4px;
  color: #71717a;
  font-size: 12px;
}

.admin-history__detail-session {
  overflow-wrap: anywhere;
}

.admin-history__filter-pill,
.admin-history__chip,
.admin-history__feedback-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.admin-history__filter-pill {
  padding: 8px 12px;
  background: #ecfdf5;
  color: #047857;
}

.admin-history__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  margin-top: 18px;
  padding-right: 4px;
}

.admin-history__card {
  width: 100%;
  padding: 18px;
  border: 1px solid #e4e4e7;
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #fafaf9 100%);
  text-align: left;
  cursor: pointer;
}

.admin-history__card:hover {
  border-color: #a7f3d0;
  background: #f8fffb;
  transform: translateY(-1px);
}

.admin-history__card.is-active {
  border-color: #34d399;
  box-shadow: 0 16px 36px -28px rgba(16, 185, 129, 0.7);
  background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);
}

.admin-history__card-top,
.admin-history__card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.admin-history__card-meta {
  min-width: 0;
}

.admin-history__card-time {
  color: #52525b;
  font-size: 12px;
}

.admin-history__card-session {
  margin-top: 4px;
  color: #a1a1aa;
  font-size: 11px;
  letter-spacing: 0.12em;
}

.admin-history__feedback-badge {
  padding: 8px 12px;
}

.admin-history__feedback-badge.is-positive {
  background: #dcfce7;
  color: #047857;
}

.admin-history__feedback-badge.is-negative {
  background: #fee2e2;
  color: #b91c1c;
}

.admin-history__feedback-badge.is-neutral {
  background: #f4f4f5;
  color: #71717a;
}

.admin-history__card-question {
  margin-top: 14px;
  color: #09090b;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.6;
}

.admin-history__card-answer {
  margin-top: 8px;
  color: #52525b;
  font-size: 13px;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.admin-history__card-footer {
  margin-top: 16px;
}

.admin-history__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.admin-history__chip {
  padding: 7px 10px;
  background: #f4f4f5;
  color: #52525b;
}

.admin-history__chip.is-faq {
  background: #f3e8ff;
  color: #7c3aed;
}

.admin-history__chip.is-llm {
  background: #dcfce7;
  color: #047857;
}

.admin-history__chip.is-mixed {
  background: #fef3c7;
  color: #b45309;
}

.admin-history__card-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #059669;
  font-size: 12px;
  font-weight: 600;
}

.admin-history__pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
}

.admin-history__page-btn {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border-radius: 12px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #52525b;
  font-size: 12px;
  font-weight: 600;
}

.admin-history__page-btn:hover:not(:disabled) {
  border-color: #a7f3d0;
  background: #f0fdf4;
}

.admin-history__page-btn.is-active {
  border-color: #10b981;
  background: #10b981;
  color: #ffffff;
}

.admin-history__page-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.admin-history__detail-shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1 auto;
  min-height: 0;
}

.admin-history__detail-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.admin-history__meta-card {
  padding: 14px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.admin-history__meta-label {
  color: #71717a;
  font-size: 11px;
}

.admin-history__meta-value {
  margin-top: 6px;
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.admin-history__messages {
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-right: 4px;
}

.admin-history__message {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-history__message.is-user {
  align-items: flex-end;
}

.admin-history__message-label {
  color: #71717a;
  font-size: 11px;
  font-weight: 700;
}

.admin-history__bubble {
  max-width: min(100%, 420px);
  padding: 14px 16px;
  border-radius: 20px;
  font-size: 13px;
  line-height: 1.7;
}

.admin-history__bubble.is-user {
  background: linear-gradient(135deg, #059669, #10b981);
  color: #ffffff;
}

.admin-history__bubble.is-assistant {
  background: #f8fafc;
  color: #18181b;
  border: 1px solid #eef2f7;
}

.admin-history__bubble-feedback {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 11px;
  opacity: 0.84;
}

.admin-history__panel-empty,
.admin-history__detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 220px;
  text-align: center;
  color: #71717a;
  font-size: 13px;
}

.admin-history__panel-empty--soft {
  flex: 1 1 auto;
  min-height: 180px;
}

.admin-history__detail-empty {
  flex: 1 1 auto;
  border: 1px dashed #d4d4d8;
  border-radius: 24px;
  background: rgba(248, 250, 252, 0.7);
}

.admin-history__detail-empty-title {
  color: #18181b;
  font-size: 16px;
  font-weight: 700;
}

.admin-history__detail-empty-copy {
  max-width: 280px;
  line-height: 1.6;
}

@media (max-width: 1280px) {
  .admin-history__hero {
    flex-direction: column;
    align-items: stretch;
  }
  .admin-history__hero-stats {
    min-width: 0;
  }
  .admin-history__workspace {
    grid-template-columns: 1fr;
  }
  .admin-history__detail-panel {
    position: static;
    max-height: none;
  }
}
@media (max-width: 900px) {
  .admin-history__hero-stats,
  .admin-history__detail-metrics {
    grid-template-columns: 1fr;
  }
  .admin-history__panel-head,
  .admin-history__detail-head,
  .admin-history__card-top,
  .admin-history__card-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .admin-history__toolbar-actions,
  .admin-history__detail-actions {
    width: 100%;
  }
  .admin-history__primary-button,
  .admin-history__ghost-button {
    flex: 1 1 auto;
  }
  .admin-history__bubble {
    max-width: 100%;
  }
}
@media (max-width: 1120px) {
  .admin-history__toolbar {
    grid-template-columns: 1fr 1fr;
  }
  .admin-history__search,
  .admin-history__toolbar-actions {
    grid-column: 1/-1;
  }
}
@media (max-width: 640px) {
  .admin-history__toolbar {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageAdminChatsComponent implements OnInit {
    public keyword: string = '';
    public filterDate: string = '';
    public sortOrder: string = 'latest';
    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 12;
    public loading: boolean = false;
    public detailOpen: boolean = false;
    public detailSession: any = null;
    public detailMsgs: any[] = [];
    public detailLoading: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindCdr(this.cdr);
        const qp = new URLSearchParams(location.search);
        await this.search(qp.get('session'));
    }

    public async search(preferredSessionId: string | null = null) {
        this.loading = true;
        await this.service.render();
        try {
            const res = await this.fetchChatList();
            const list = res?.rows || res?.items || [];
            const rows = Array.isArray(list) ? list : [];
            const dateFilteredRows = this.filterRowsByDate(rows);
            this.rows = dateFilteredRows.rows;
            this.total = dateFilteredRows.usedFallback ? dateFilteredRows.rows.length : (res?.total ?? res?.count ?? 0);
        } catch (e: any) {
            this.rows = [];
            this.total = 0;
            this.clearDetailState();
            this.service.alert(e.message || String(e));
        } finally {
            this.loading = false;
        }
        await this.service.render();
        if (!this.rows.length) {
            this.clearDetailState();
            await this.service.render();
            return;
        }
        await this.syncDetailSelection(preferredSessionId);
    }

    public async changePage(p: number) {
        if (p < 1) return;
        const maxPage = Math.max(1, Math.ceil(this.total / this.dump));
        if (p > maxPage) return;
        this.page = p;
        await this.search();
    }

    public async onKey(e: KeyboardEvent) {
        if (e.key === 'Enter') {
            await this.applyFilters();
        }
    }

    public async applyFilters() {
        this.page = 1;
        await this.search();
    }

    public async onDateChange(value: string) {
        this.filterDate = value || '';
        await this.applyFilters();
    }

    public async onSortChange(value: string) {
        this.sortOrder = value === 'oldest' ? 'oldest' : 'latest';
        await this.applyFilters();
    }

    public async resetFilters() {
        if (!this.hasActiveFilters()) return;
        this.keyword = '';
        this.filterDate = '';
        this.sortOrder = 'latest';
        this.page = 1;
        await this.search();
    }

    public hasActiveFilters(): boolean {
        return !!this.keyword || !!this.filterDate || this.sortOrder !== 'latest';
    }

    public activeFilterLabel(): string {
        const labels: string[] = [];
        if (this.filterDate) labels.push(this.filterDate);
        if (this.keyword) labels.push(this.keyword);
        if (this.sortOrder !== 'latest') labels.push(this.sortLabel(this.sortOrder));
        return labels.join(' · ');
    }

    public sortLabel(sort: string): string {
        if (sort === 'oldest') return '오래된순';
        return '최신순';
    }

    private async fetchChatList(): Promise<any> {
        const params = new URLSearchParams();
        params.set('keyword', this.keyword || '');
        params.set('selected_date', this.filterDate || '');
        params.set('date', this.filterDate || '');
        params.set('sort', this.sortOrder || 'latest');
        params.set('page', String(this.page));
        params.set('dump', String(this.dump));

        const res = await fetch(`/api/ggeea/admin/chats/list?${params.toString()}`, {
            method: 'POST',
            credentials: 'include',
        });
        const body = await res.json().catch(() => ({}));
        const code = typeof body?.code === 'number' ? body.code : res.status;
        if (code !== 200) {
            throw new Error(body.message || `API chats/list failed (${code})`);
        }
        return body?.data?.data ?? body?.data ?? body;
    }

    private filterRowsByDate(rows: any[]): { rows: any[]; usedFallback: boolean } {
        if (!this.filterDate) return { rows, usedFallback: false };
        const filtered = rows.filter((row) => this.rowDate(row) === this.filterDate);
        return {
            rows: filtered,
            usedFallback: filtered.length !== rows.length,
        };
    }

    private rowDate(row: any): string {
        const value = row?.created_at ? String(row.created_at) : '';
        return value.slice(0, 10);
    }

    public async openDetail(row: any, force: boolean = false) {
        if (!row?.session_id) return;
        const sameSession = this.detailSession?.session_id === row.session_id;
        this.detailOpen = true;
        this.detailSession = row;
        if (sameSession && this.detailMsgs.length > 0 && force === false) {
            await this.service.render();
            return;
        }
        if (!sameSession) {
            this.detailMsgs = [];
        }
        this.detailLoading = true;
        await this.service.render();
        try {
            const detail = await this.service.api('chats', 'detail', { session_id: row.session_id });
            this.detailMsgs = Array.isArray(detail) ? detail : [];
        } catch (e: any) {
            this.detailMsgs = [];
            this.service.alert(e.message || String(e));
        } finally {
            this.detailLoading = false;
        }
        await this.service.render();
    }

    public async closeDetail() {
        this.clearDetailState();
        await this.service.render();
    }

    public maxPage(): number {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public pages(): number[] {
        const maxPage = this.maxPage();
        const start = Math.max(1, this.page - 2);
        const end = Math.min(maxPage, start + 4);
        const values: number[] = [];
        for (let page = start; page <= end; page++) values.push(page);
        return values;
    }

    public resultStart(): number {
        if (this.total === 0) return 0;
        return ((this.page - 1) * this.dump) + 1;
    }

    public resultEnd(): number {
        if (this.total === 0) return 0;
        return Math.min(this.page * this.dump, this.total);
    }

    public pageRangeLabel(): string {
        if (this.total === 0) return '0';
        return `${this.resultStart()} - ${this.resultEnd()}`;
    }

    public pageSummary(): string {
        if (this.total === 0) return '검색 결과가 없습니다.';
        return `${this.pageRangeLabel()} / ${this.total}건`;
    }

    public feedbackTone(row: any): string {
        if (row?.had_positive) return 'positive';
        if (row?.had_negative) return 'negative';
        return 'neutral';
    }

    public feedbackLabel(row: any): string {
        if (row?.had_positive) return '긍정';
        if (row?.had_negative) return '부정';
        return '미평가';
    }

    public sessionSourceTone(row: any): string {
        const faq = Number(row?.faq_turn_count || 0);
        const llm = Number(row?.llm_turn_count || 0);
        if (faq > 0 && llm > 0) return 'mixed';
        if (faq > 0) return 'faq';
        if (llm > 0) return 'llm';
        return 'none';
    }

    public sessionSourceLabel(row: any): string {
        const faq = Number(row?.faq_turn_count || 0);
        const llm = Number(row?.llm_turn_count || 0);
        if (faq > 0 && llm > 0) return `FAQ ${faq} · LLM ${llm}`;
        if (faq > 0) return `FAQ ${faq}`;
        if (llm > 0) return `LLM ${llm}`;
        return '응답 없음';
    }

    public detailSourceLabel(message: any): string {
        if (message?.role === 'user') {
            return message?.intent === 'faq' ? '사용자 · FAQ 선택' : '사용자';
        }
        return message?.intent === 'faq' ? 'FAQ 답변' : 'LLM 답변';
    }

    public shortSessionId(sessionId: string): string {
        const value = String(sessionId || '').trim();
        if (!value) return 'SESSION';
        return value.slice(0, 8).toUpperCase();
    }

    public trackSession(index: number, row: any) {
        return row?.session_id || index;
    }

    private async syncDetailSelection(preferredSessionId: string | null = null) {
        const targetSessionId = preferredSessionId || this.detailSession?.session_id || '';
        const target = this.rows.find((row) => row.session_id === targetSessionId) || this.rows[0];
        if (!target) {
            this.clearDetailState();
            await this.service.render();
            return;
        }
        if (this.detailSession?.session_id === target.session_id && this.detailMsgs.length > 0) {
            this.detailSession = target;
            this.detailOpen = true;
            await this.service.render();
            return;
        }
        await this.openDetail(target);
    }

    private clearDetailState() {
        this.detailOpen = false;
        this.detailSession = null;
        this.detailMsgs = [];
        this.detailLoading = false;
    }
}

export default PageAdminChatsComponent;